import React, { useState } from 'react';

const defaultValue = {
  gestoesEnvio: [],
  gestaoEnvioAtual: {},
  selecao: [],
  somatorios: {},
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  email: '',
  filtroAvancado: {},
  limitarCategorias: false,
  page: 0,
  size: 15,
  sort: 'dataHoraEnvio,DESC',
};

export const GestaoEnvioContext = React.createContext({});

export const GestaoEnvioProvider = (props) => {
  return (
    <GestaoEnvioContext.Provider
      value={{
        gestoesEnvio: useState(defaultValue.gestoesEnvio),
        gestaoEnvioAtual: useState(defaultValue.gestaoEnvioAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        somatorios: useState(defaultValue.somatorios),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        email: useState(defaultValue.email),
        filtroAvancado: useState(defaultValue.filtroAvancado),
        limitarCategorias: useState(defaultValue.limitarCategorias),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </GestaoEnvioContext.Provider>
  );
};

export const GestaoEnvioConsumer = GestaoEnvioContext.Consumer;
